const {cover}=require('./project-motion.js');
document.querySelectorAll('[data-work-slider]').forEach(slider => {
 const track=slider.querySelector('.one-work__track');
 const cards=[...slider.querySelectorAll('[data-work-card]')];
 const selectors=[...slider.querySelectorAll('[data-work-select]')];
 if (!cards.length) return;
 const prev=slider.querySelector('[data-work-prev]');
 const next=slider.querySelector('[data-work-next]');
 const status=slider.querySelector('[data-work-status]');
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches||document.documentElement.classList.contains('motion-paused');
 let current=0, timer, frame, drag=null, suppressClick=false;
 const position=index=>cards[index].offsetLeft-cards[0].offsetLeft;
 const select=index=>{
  current=Math.max(0,Math.min(index,cards.length-1));
  selectors.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===current)));
  slider.querySelector('[data-work-current]').textContent=String(current+1).padStart(2,'0');
  prev.disabled=current===0;next.disabled=current===cards.length-1;
 };
 const go=(index,preview=false)=>{
  clearTimeout(previewTimer);
  index=Math.max(0,Math.min(index,cards.length-1));
  select(index);
  track.scrollTo({left:position(index),behavior:preview||reduced()?'instant':'smooth'});
  if(preview)cover(cards[index].querySelector('.one-work__canvas'));
 };
 const nearest=()=>cards.reduce((best,card,i)=>Math.abs(position(i)-track.scrollLeft)<Math.abs(position(best)-track.scrollLeft)?i:best,0);
 const announce=()=>{
  status.textContent=`Projekt ${current+1} von ${cards.length}: ${cards[current].dataset.projectTitle}`;
  const button=selectors[current], list=button.parentElement;
  if(button.offsetLeft<list.scrollLeft||button.offsetLeft+button.offsetWidth>list.scrollLeft+list.clientWidth)list.scrollTo({left:button.offsetLeft-list.clientWidth/2+button.offsetWidth/2,behavior:reduced()?'instant':'smooth'});
 };
 prev.addEventListener('click',()=>go(current-1));
 next.addEventListener('click',()=>go(current+1));
 selectors.forEach((button,i)=>button.addEventListener('click',()=>{go(i);announce();}));
 let previewTimer;
 selectors.forEach((button,i)=>{
  button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&matchMedia('(min-width:1280px)').matches&&i!==current)previewTimer=setTimeout(()=>go(i,true),140);});
  button.addEventListener('pointerleave',()=>clearTimeout(previewTimer));
  button.addEventListener('keydown',event=>{
   const index={ArrowDown:i+1,ArrowUp:i-1,Home:0,End:cards.length-1}[event.key];
   if(index===undefined)return;
   event.preventDefault();const target=Math.max(0,Math.min(index,cards.length-1));selectors[target].focus({preventScroll:true});go(target,true);announce();
  });
 });
 track.addEventListener('keydown',event=>{
  const target={ArrowLeft:current-1,ArrowRight:current+1,Home:0,End:cards.length-1}[event.key];
  if(target===undefined)return;
  event.preventDefault();go(target);
  if(event.target.closest('[data-work-card]'))cards[current].querySelector('a').focus({preventScroll:true});
 });
 track.addEventListener('focusin',event=>{
  const card=event.target.closest('[data-work-card]');
  if(card)go(cards.indexOf(card));
 });
 track.addEventListener('scroll',()=>{
  cancelAnimationFrame(frame);
  frame=requestAnimationFrame(()=>select(nearest()));
  clearTimeout(timer);timer=setTimeout(announce,180);
 },{passive:true});
 // Touch/trackpad use native scrolling; only mouse dragging needs enhancement.
 track.addEventListener('pointerdown',event=>{
  if(event.pointerType==='mouse'&&event.button===0)drag={x:event.clientX,left:track.scrollLeft,id:event.pointerId,moved:false};
 });
 track.addEventListener('pointermove',event=>{
  if(!drag)return;
  const distance=event.clientX-drag.x;
  if(!drag.moved&&Math.abs(distance)<8)return;
  drag.moved=true;suppressClick=true;
  track.setPointerCapture(drag.id);track.classList.add('is-dragging');
  track.scrollLeft=drag.left-distance;
 });
 const endDrag=()=>{
  if(!drag)return;
  const moved=drag.moved;
  if(track.hasPointerCapture(drag.id))track.releasePointerCapture(drag.id);
  drag=null;track.classList.remove('is-dragging');
  if(moved)go(nearest());
  setTimeout(()=>{suppressClick=false;},0);
 };
 track.addEventListener('pointerup',endDrag);
 track.addEventListener('pointercancel',endDrag);
 track.addEventListener('pointerleave',()=>{if(drag&&!drag.moved)drag=null;});
 track.addEventListener('dragstart',event=>event.preventDefault());
 track.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopPropagation();}},true);
 new ResizeObserver(()=>track.scrollTo({left:position(current),behavior:'instant'})).observe(track);
 select(0);slider.classList.add('is-ready');
});
